var render, staticRenderFns
import script from "./ReportSummaryAltAuth.vue?vue&type=script&lang=ts&"
export * from "./ReportSummaryAltAuth.vue?vue&type=script&lang=ts&"
import style0 from "./ReportSummaryAltAuth.vue?vue&type=style&index=0&id=48edb8d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edb8d1",
  null
  
)

export default component.exports